import { useCallback, useEffect, useMemo, useState } from 'react'
import { useUserInfoContext } from '@/store/userInfo'
import styles from '../style.module.less'

const menus = [
  {
    title: '工作台',
    key: 'workbench'
  },
  {
    title: '投标与签约',
    key: 'tbqy',
    permissionKey: 'TBYQY'
  },
  {
    title: '部门经营',
    key: 'bmjy',
    permissionKey: 'BMJY'
  }
]

const Index = ({onChange}) => {
  const [active, setActive] = useState()
  const { topPermissions } = useUserInfoContext()

  const handleClick = useCallback((m) => {
    setActive(m.key)
    if(typeof onChange === 'function') {
      onChange(m)
    }
  }, [onChange])

  // 默认打开工作台
  useEffect(() => {
    handleClick(menus[0])
  }, [handleClick])

  const renderMenus = useMemo(() => {
    return menus.filter(m => {
      if(!m.permissionKey) {
        return true
      }
      return topPermissions.some(t => t.ANMC === m.permissionKey)
    })
  }, [topPermissions])

  return (
    <>
      {
        renderMenus.map(m => <div key={m.key} onClick={() => handleClick(m)} className={`${styles['top-nav-item']} ${active === m.key && styles.active}`}>{m.title}</div>)
      }
      
    </>
  )
}

export default Index
